<script lang="typescript">
  export let etiquette:string;
</script>

<div>
  {@html etiquette}
</div>

<style>
</style>

